import { render, staticRenderFns } from "./Camps.vue?vue&type=template&id=b215a1fa&scoped=true&"
import script from "./Camps.vue?vue&type=script&lang=js&"
export * from "./Camps.vue?vue&type=script&lang=js&"
import style0 from "./Camps.vue?vue&type=style&index=0&id=b215a1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b215a1fa",
  null
  
)

export default component.exports